import React, { useState, useCallback, useEffect } from "react";
import VoiceArt from "../../../../assets/images/voice-art.png";
import TanakaReal from "../../../../assets/images/tanaka.png";
import TanakaAvatar from "../../../../assets/images/tanaka_avatar.png";
import ShimboReal from "../../../../assets/images/shimbo.jpg";
import ShimboAvatar from "../../../../assets/images/shimbo_avatar.png";
import styles from "./VoiceSection.scss";
import { useScrollAnimation } from "../hooks/useScrollAnimation";

export function VoiceSection() {
  const voices = [
    {
      id: 1,
      name: "田中 孝佳",
      nameEn: "Takayoshi Tanaka",
      title: "東京科学大学 特任准教授\nソーシャルデザインパートナーズ株式会社 代表",
      comment: "「妄想を、構想に。構想を、社会に」\n——MetaCampUsが拓く、共創の新しいかたち",
      detailContent: {
        mainTitle: "「妄想を、構想に。構想を、社会に」",
        subtitle: "——MetaCampUsが拓く、共創の新しいかたち",
        sections: [
          {
            body: `皆さん、こんにちは。
東京科学大学の特任准教授であり、ソーシャルデザインパートナーズ株式会社の代表を務めている田中です。
MetaCampUsでは、企画構想から実装に至るまでの監修を担当しました。
私自身、普段は地方創生の現場に携わりつつ、こうしてメタバース上でコミュニティを設計・実装するという、少し不思議な経験をしていますが、根っこにある想いは同じだと思っています。`
          },
          {
            title: "「想い」から始まる構想が、生まれにくい時代に。",
            body: `いまの世の中で、純粋に「やりたいこと」を形にするのは、思っている以上に難しい。
どうしてもマーケットインの発想が主流で、儲かるビジネスや副業、即効性のあるスキルに目が向きがちです。
でも、社会を大きく動かしてきたのは、最初から利益を計算して始めた事業ではなく、たとえばGoogleやFacebookのように、偏愛や違和感から生まれた衝動的な想いだったと思うんです。
MetaCampUsは、そんな想いから始まる構想——いや、妄想が芽吹く場所をつくりたい。たとえ最初は小さくても、そこに共感や共鳴が生まれた瞬間に、多くは夢物語かもしれないけれど、稀に社会を変える力を持ち得る。まぁこれもまた、私自身の妄想に過ぎませんが。`
          },
          {
            title: "想いをつなぎ、形にしていく共創の生態系を。",
            body: `MetaCampUsを単なるオンラインキャンパスとは思っていません。
目指しているのは、さまざまなコミュニティを包み込むプラットフォームです。誰かの想いがラボとなり、仲間が集まり、プロジェクトが生まれる。その中からまた別のコミュニティや仕組みが派生し、新しい活動が次々と芽吹いていく。
そうやって、想いが想いを呼び、構想が構想を育てるような、共創の生態系を育てていくこと。それがMetaCampUsの本質であり、想いの火種が絶えない社会をつくるための、小さな実験かなと思って取り組んでいます。`
          },
          {
            title: "社会を動かすのは、妄想力。",
            body: `私はこれまで、地域再生や宿泊施設の開発、企業の新規事業など、いわば構想から実装までを伴走するプロジェクトを数多く手がけてきました。
そこで確信したのは、社会を動かす原動力は、結局のところ構想力、さらには妄想力だということです。技術や資金を超えて、「こうありたい」という想いを構造化し、仲間と共有できる力。MetaCampUsを通じて、そんな妄想力を育み、社会に還元する循環をつくりたいと思っています。`
          },
          {
            title: "妄想から共創へ。その一歩を、共に。",
            body: `MetaCampUsは、誰かの夢を実現するためのプラットフォームであると同時に、一人ひとりが他者の夢に関わっていくための町でもあります。ここでの出会いや対話が、次の学びや活動につながっていく。共に想い、共に創る。そんな循環を、ぜひ体験してほしいと思います。`
          }
        ]
      },
      realPhoto: TanakaReal,
      avatarPhoto: TanakaAvatar
    },
    {
      id: 2,
      name: "新保 正悟",
      nameEn: "Shogo Shimbo",
      title: "株式会社VLEAP 代表取締役",
      comment: "「人が集い、関わり続けられる場」を目指して\n——関係性が育つ空間設計",
      detailContent: {
        mainTitle: "「人が集い、関わり続けられる場」を目指して",
        subtitle: "——関係性が育つ空間設計",
        sections: [
          {
            body: `MetaCampUsの開発を担当した株式会社VLEAPの新保です。
私たちは本プロジェクトにおいて、構想段階から実装まで伴走しながら、「この場を、実際に人が集い、関わり続けられる体験としてどう成立させるか」という視点で開発に取り組んできました。

MetaCampUsが大切にしているのは、起業やプロジェクトを完成されたアイデアから始めることではありません。
まだ輪郭の定まらない考えや問いが、人との出会いや対話を通じて少しずつ形を成していく——
そのプロセス自体を支えることが、このキャンパスの根底にある思想だと捉えています。`
          },
          {
            title: "人の気配が消えない空間をどうつくるか",
            body: `メタバース空間は、人の存在が薄れると途端に「寒さ」を感じさせてしまうことがあります。
だからこそ私たちは、いかに人が積極的に入り続け、関係性が育ち続ける温かみのある空間を維持できるかを、設計の中心に据えました。

MetaCampUsのエントランスに鎮座する一本の大樹は、そうした考え方を体現した存在です。
人や活動が集まり、枝分かれしながら広がっていく。
起業やプロジェクトもまた、個人の中だけで完結するものではなく、関係性の中で育っていくものだというメッセージを、空間として表現しています。`
          },
          {
            title: "起業の入口としてのアフォーダンス",
            body: `MetaCampUsでは、「すでに起業を目指している人」だけでなく、
「まだ何をやりたいか分からない人」や
「誰かの構想に関わってみたい人」も自然に居場所を見つけられることを重視しています。

そのために、空間そのものが行動を後押しするアフォーダンスを用意しました。
※ アフォーダンス
たとえばドアノブを見ると、説明がなくても「回せば開く」と分かるように、ここでは空間のつくりによって「次にどう関わればいいか」が自然と伝わる状態を指しています。

MetaCampUsでは、初めて訪れた人でも無理なく行動できることを大切にしています。

・砕けた会話から関係性が生まれやすい 横丁ワールド
・想いを言葉にしやすい距離感を意識した ミーティングワールド
・起業に関する知識や事例に触れ、学びを深められる メディアセンターワールド

これらの空間を行き来する中で、
知る → 話す → 関わる → 形にする、という流れが自然に生まれていく。
MetaCampUsは、起業を特別な人だけのものではなく、関係性の延長線上にある選択肢として位置づけています。`
          },
          {
            title: "経験を組み込み、これからも更新していく",
            body: `私たちはこれまで、東京都や大学と連携し、教育を目的としたメタバース空間の設計・開発に取り組んできました。
そこで培ってきたのは、知識や答えを一方的に伝える場ではなく、人が学び、対話し、試行錯誤できる環境をどう成立させるかという視点です。

その経験は、MetaCampUsの設計思想として組み込まれているだけでなく、
今後このキャンパスに集う人々や起業のかたちによって、さらに更新され、活かされていくものだと考えています。`
          },
          {
            title: "これからも続く、場づくりの伴走者として",
            body: `MetaCampUsは、リリースして完成するプロダクトではありません。
人が集い、関わり続けることで、起業のかたちも、学びのかたちも変化していくキャンパスです。

私たちは開発会社として、そして伴走者として、
この場に生まれる関係性が、次の挑戦へとつながっていくプロセスを、これからも技術と設計の両面から支えていきます。`
          }
        ]
      },
      realPhoto: ShimboReal,
      avatarPhoto: ShimboAvatar
    },
    {
      id: 3,
      comingSoon: true
    }
  ];

  // モーダル表示用のstate
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedVoice, setSelectedVoice] = useState(null);

  const openModal = useCallback(voice => {
    setSelectedVoice(voice);
    setModalOpen(true);
    document.body.style.overflow = "hidden";
  }, []);

  const closeModal = useCallback(() => {
    setModalOpen(false);
    setTimeout(() => setSelectedVoice(null), 300);
    document.body.style.overflow = "";
  }, []);

  useEffect(() => {
    const handleEsc = e => {
      if (e.key === "Escape") closeModal();
    };
    if (modalOpen) {
      window.addEventListener("keydown", handleEsc);
    }
    return () => window.removeEventListener("keydown", handleEsc);
  }, [modalOpen, closeModal]);

  // マウス位置を追跡するstate
  const [mousePos, setMousePos] = useState({ x: 50, y: 50 });
  const [hoveringId, setHoveringId] = useState(null);

  const handleMouseMove = useCallback(e => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    setMousePos({ x, y });
  }, []);

  const handleMouseEnter = useCallback((id) => {
    setHoveringId(id);
  }, []);

  const handleMouseLeave = useCallback(() => {
    setHoveringId(null);
  }, []);

  // スクロールアニメーション
  const [holeRef, holeVisible] = useScrollAnimation({ threshold: 0.3 });
  const [cardsRef, cardsVisible] = useScrollAnimation({ threshold: 0.2 });

  return (
    <section id="voice" className={styles.voiceSection}>
      {/* アート画像 - セクション基準で配置 */}
      <img
        src={VoiceArt}
        alt=""
        className={`${styles.holeArt} ${holeVisible ? styles.artAnimate : styles.artHidden}`}
      />
      {/* 不定形の緑のくぼみ穴 */}
      <div
        ref={holeRef}
        className={`${styles.holeContainer} ${holeVisible ? styles.holeAnimate : styles.holeHidden}`}
      >
        {/* アニメーションする穴 */}
        <svg className={styles.holeSvg} viewBox="-10 -10 120 120" preserveAspectRatio="none">
          <defs>
            <linearGradient id="voiceHoleGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#C4E4D2" />
              <stop offset="50%" stopColor="#BEDBE4" />
              <stop offset="100%" stopColor="#C4E4D2" />
            </linearGradient>
            <filter id="voiceInnerShadow" x="-50%" y="-50%" width="200%" height="200%">
              <feFlood floodColor="black" floodOpacity="1" result="flood" />
              <feComposite in="flood" in2="SourceAlpha" operator="out" result="outside" />
              <feOffset in="outside" dx="3" dy="3" result="offsetShadow" />
              <feGaussianBlur in="offsetShadow" stdDeviation="4" result="blurShadow" />
              <feComposite in="blurShadow" in2="SourceAlpha" operator="in" result="innerShadow" />
              <feColorMatrix
                in="innerShadow"
                type="matrix"
                result="coloredShadow"
                values="0 0 0 0 0
                        0 0 0 0 0
                        0 0 0 0 0
                        0 0 0 0.5 0"
              />
              <feMerge>
                <feMergeNode in="SourceGraphic" />
                <feMergeNode in="coloredShadow" />
              </feMerge>
            </filter>
          </defs>
          <path fill="url(#voiceHoleGradient)" filter="url(#voiceInnerShadow)">
            <animate
              attributeName="d"
              dur="20s"
              repeatCount="indefinite"
              values="
                M 18 12 C 25 -2 42 -2 52 10 S 78 -2 90 18 S 108 48 92 62 S 108 88 82 98 S 48 108 32 88 S -2 98 2 68 S -8 28 18 12 Z;
                M 15 18 C 28 2 38 5 55 8 S 82 2 92 22 S 105 52 88 68 S 102 92 78 102 S 45 105 28 85 S 2 92 5 62 S -5 32 15 18 Z;
                M 20 8 C 32 -5 45 0 52 15 S 75 0 88 15 S 110 42 95 58 S 112 85 85 95 S 52 110 35 92 S -5 102 0 72 S -10 25 20 8 Z;
                M 18 12 C 25 -2 42 -2 52 10 S 78 -2 90 18 S 108 48 92 62 S 108 88 82 98 S 48 108 32 88 S -2 98 2 68 S -8 28 18 12 Z
              "
            />
          </path>
        </svg>
      </div>
      <div className={styles.voiceContainer}>
        <h2 className={styles.voiceTitle}>Voice</h2>
        <p className={styles.voiceSubtitle}>立ち上げメンバーの想いを紹介します</p>
        <div ref={cardsRef} className={styles.voiceCards}>
          {voices.map((voice, index) =>
            voice.comingSoon ? (
              <div
                key={voice.id}
                className={`${styles.voiceCard} ${styles.comingSoonCard} ${cardsVisible ? styles.cardAnimate : styles.cardHidden}`}
                style={{ animationDelay: `${index * 0.15}s` }}
              >
                <div className={styles.comingSoonContainer}>
                  <div className={styles.comingSoonText}>準備中</div>
                </div>
              </div>
            ) : (
              <div
                key={voice.id}
                className={`${styles.voiceCard} ${cardsVisible ? styles.cardAnimate : styles.cardHidden}`}
                style={{ animationDelay: `${index * 0.15}s` }}
              >
                {/* 写真エリア - 実写とアバターの重ね合わせ */}
                {voice.realPhoto && voice.avatarPhoto ? (
                  <div
                    className={styles.photoContainer}
                    onMouseMove={handleMouseMove}
                    onMouseEnter={() => handleMouseEnter(voice.id)}
                    onMouseLeave={handleMouseLeave}
                  >
                    {/* 実写画像（下レイヤー） */}
                    <img src={voice.realPhoto} alt={`${voice.name}の実写`} className={styles.realPhoto} />
                    {/* アバター画像（上レイヤー、マウス位置で穴が開く） */}
                    <img
                      src={voice.avatarPhoto}
                      alt={`${voice.name}のアバター`}
                      className={styles.avatarPhoto}
                      style={
                        hoveringId === voice.id
                          ? {
                              maskImage: `radial-gradient(circle 100px at ${mousePos.x}% ${mousePos.y}%, transparent 0%, transparent 100%, black 100%)`,
                              WebkitMaskImage: `radial-gradient(circle 100px at ${mousePos.x}% ${mousePos.y}%, transparent 0%, transparent 100%, black 100%)`
                            }
                          : {}
                      }
                    />
                  </div>
                ) : (
                  <div className={styles.emojiPhotoContainer}>
                    <div className={styles.emojiAvatar}>{voice.avatar}</div>
                  </div>
                )}
                {/* テキストエリア */}
                <div className={styles.cardContent}>
                  <p className={styles.voiceComment}>{voice.comment}</p>
                  <div className={styles.voiceFooter}>
                    <div className={styles.voiceName}>{voice.name}</div>
                    <div className={styles.voiceNameEn}>{voice.nameEn}</div>
                    <button className={styles.detailButton} onClick={() => openModal(voice)}>詳しく見る <span className={styles.detailArrow}>&gt;</span></button>
                  </div>
                </div>
              </div>
            )
          )}
        </div>
        <div className={styles.scrollIndicator}>スワイプ</div>
      </div>

      {/* 詳細モーダル */}
      {selectedVoice && selectedVoice.detailContent && (
        <div
          className={`${styles.modalOverlay} ${modalOpen ? styles.modalOpen : styles.modalClosing}`}
          onClick={closeModal}
        >
          <div className={styles.modalContainer} onClick={e => e.stopPropagation()}>
            <button className={styles.modalCloseButton} onClick={closeModal} aria-label="閉じる">
              <span className={styles.closeIcon}></span>
            </button>

            <div className={styles.modalContent}>
              {/* ヘッダー部分 */}
              <div className={styles.modalHeader}>
                <div className={styles.modalAuthorInfo}>
                  <img
                    src={selectedVoice.realPhoto}
                    alt={selectedVoice.name}
                    className={styles.modalAuthorPhoto}
                  />
                  <div className={styles.modalAuthorDetails}>
                    <div className={styles.modalAuthorName}>{selectedVoice.name}</div>
                    <div className={styles.modalAuthorTitle}>{selectedVoice.title}</div>
                  </div>
                </div>
              </div>

              {/* メインタイトル */}
              <div className={styles.modalTitleArea}>
                <h2 className={styles.modalMainTitle}>{selectedVoice.detailContent.mainTitle}</h2>
                <p className={styles.modalSubtitle}>{selectedVoice.detailContent.subtitle}</p>
              </div>

              {/* 本文セクション */}
              <div className={styles.modalBody}>
                {selectedVoice.detailContent.sections.map((section, index) => (
                  <div key={index} className={styles.modalSection}>
                    {section.title && <h3 className={styles.modalSectionTitle}>{section.title}</h3>}
                    <p className={styles.modalSectionBody}>{section.body}</p>
                  </div>
                ))}
              </div>

              {/* フッター */}
              <div className={styles.modalFooter}>
                <div className={styles.modalSignature}>
                  <span className={styles.signatureName}>{selectedVoice.name}</span>
                  <span className={styles.signatureNameEn}>{selectedVoice.nameEn}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
